import React from 'react'
import { Link } from 'react-router-dom'
import constants from '../../constants'
import _ from 'lodash'

class OpenType extends React.Component {
  constructor(props) {
    super(props);
  }

  openTypeSelected = () => {
    this.props.onOpenTypeSelected(this.props.item);
  };

  render() {
    return (
      <div className='form-item'>
        <div className={`selectable-block checkbox- small-option- ${this.props.item.id == _.get(this.props.selected_open, 'id') ? 'selected' : ''}`}
             onClick={this.openTypeSelected}>
          <label>
            <div className='label- with-icon'>
              <div className='icon-'>
                <img src={this.props.item.img} />
              </div>
              { this.props.item.title }
            </div>
            <div className='selectable-block-indicator'></div>
          </label>
        </div>
      </div>
    )
  }
}

export default OpenType;



// WEBPACK FOOTER //
// ./app/javascript/app/components/open_type/index.jsx